import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import Admin from "@/pages/Admin";
import SmoothScroll from "@/components/SmoothScroll";
import { QuoteProvider } from "@/components/QuoteModal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Toaster theme="dark" position="top-center" richColors />
        <QuoteProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </QuoteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
